export const martialStatusOptions = ["Married", "Single"];
//# sourceMappingURL=martialStatus.js.map